// Informações da edição atual do torneio exibidas nas páginas de inscrição.
export const EVENTO = {
  datas: '02/10/2026 e 03/10/2026',
  formato: 'O torneio será composto por 6 times de 6 jogadores, formatado em 2 grupos de 3 times com semifinais e final.',
  agenda: [
    { quando: '02/10 · 19:00', oque: 'Fase de grupos' },
    { quando: '03/10 · 15:00', oque: 'Semifinais e final' },
    { quando: '03/10 · 18:30', oque: 'Festa de encerramento' },
  ],
  festa: 'A festa será all inclusive com chopp, drinks e buffet. Para animar, duas bandas que ainda serão contratadas.',
};

export const VALORES = [
  { titulo: 'Torneio + Festa', valor: 'R$ 200,00', detalhe: 'Inclui a camisa oficial, obrigatória para jogar', destaque: true },
  { titulo: 'Apenas torneio', valor: 'R$ 120,00' },
  { titulo: 'Acompanhante', valor: 'R$ 150,00', detalhe: 'Acesso à festa' },
];
